var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcidssLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 300,
    viewBox: "0 0 301 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_447_632)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_447_632",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 60,
    width: 301,
    height: 181
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.488 60.1562H0.488037V240.625H300.488V60.1562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_447_632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.285 178.672L272.676 173.828L267.676 162.735C264.004 167.344 260.332 173.281 257.285 178.672ZM252.051 127.969L221.894 60.7812L1.11304 73.2812L62.2849 240.156L180.019 203.047C172.519 192.266 169.785 179.453 178.457 173.203C188.144 166.172 202.754 174.297 212.051 185.781C221.035 170.781 246.269 135.86 252.051 127.969Z",
    fill: "#225E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.016 109.334C224.235 109.334 231.735 102.303 231.735 93.5529C231.735 84.8029 224.235 77.7715 215.016 77.7715C205.797 77.7715 198.297 84.8029 198.297 93.5529C198.297 102.225 205.797 109.334 215.016 109.334ZM201.344 116.131H228.688V187.615H201.344V116.131Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.829 136.991C188.063 137.069 188.219 136.991 188.219 136.757V118.632C188.219 118.397 188.063 118.163 187.829 118.007C187.829 118.007 184.235 115.663 173.297 115.038C172.75 114.725 163.141 114.647 160.563 115.038C120.719 118.241 119.235 147.069 119.235 148.319V155.35C119.235 156.21 119.235 185.663 160.563 188.241C164.625 188.554 172.516 188.241 173.297 188.241C182.829 188.241 189.391 185.35 189.391 185.35C189.625 185.272 189.782 185.038 189.782 184.804V167.85C189.782 167.616 189.625 167.538 189.469 167.694C189.469 167.694 186.5 170.038 173.532 171.366C169.86 171.757 168.063 171.6 166.735 171.366C148.297 168.241 147.438 154.804 147.438 154.804C147.438 154.569 147.36 154.179 147.36 154.022V148.866C147.36 148.632 147.36 148.241 147.438 148.085C147.438 148.085 148.688 133.632 166.735 132.069H173.532C181.422 133.085 187.829 136.991 187.829 136.991Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2974 187.38C43.2974 187.614 43.4536 187.771 43.688 187.771H70.3286C70.563 187.771 70.7192 187.614 70.7192 187.38V166.599C70.7192 166.364 70.8755 166.208 71.1099 166.208C71.1099 166.208 113.688 169.255 113.688 140.739C113.688 118.161 86.9694 115.739 78.2192 116.13C78.063 116.13 43.688 116.13 43.688 116.13C43.4536 116.13 43.2974 116.286 43.2974 116.521V187.38ZM70.2505 150.349V131.677H76.813C76.813 131.677 86.2663 132.067 87.0475 138.552C87.2038 139.021 87.2038 142.224 87.0475 142.38C85.7975 149.958 77.5942 150.349 77.5942 150.349H70.2505Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.801 222.108C217.988 222.108 219.707 222.108 222.519 220.858C232.207 215.78 264.941 135.858 299.472 111.249C299.707 111.092 299.941 110.858 300.097 110.624C300.332 110.311 300.332 109.999 300.332 109.999C300.332 109.999 300.332 108.358 295.254 108.358C264.551 107.499 232.597 171.952 215.801 197.421C215.566 197.733 214.472 197.421 214.472 197.421C214.472 197.421 203.222 184.139 193.457 179.061C193.222 178.983 192.129 178.592 190.957 178.671C190.176 178.671 185.644 179.608 183.535 181.796C181.035 184.452 181.113 185.936 181.113 189.139C181.113 189.374 181.269 190.467 181.582 191.014C184.004 195.233 194.863 210.233 203.847 218.514C205.176 219.53 207.285 222.108 215.801 222.108Z",
    fill: "#2BBC5D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_447_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "translate(0.488037)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcidssLogo);
export default __webpack_public_path__ + "static/media/pcidss-logo.739346f8.svg";
export { ForwardRef as ReactComponent };